module.exports = __webpack_public_path__ + "img/book.e300b78d.png";